import * as React from 'react';

interface CTAButtonProps {
	text: string;
	iconUrl?: string;
	bgColor?: 'yaap-white' | 'yaap-yellow' | 'yaap-black' | 'yaap-gray';
	textColor?: 'yaap-white' | 'yaap-black' | 'yaap-gray' | 'yaap-yellow';
	onClick?: () => void;
}

export const CTAButton: React.FC<CTAButtonProps> = ({
	text,
	iconUrl,
	bgColor = 'yaap-white',
	textColor = 'yaap-black',

	onClick,
}) => {
	// Define background color classes
	const bgColorClasses = {
		'yaap-white': 'bg-white',
		'yaap-yellow': 'bg-[#fbb040]',
		'yaap-black': 'bg-[#0C1518]',
		'yaap-gray': 'bg-[#8F9FA3]',
	};

	// Define text color classes
	const textColorClasses = {
		'yaap-white': 'text-white',
		'yaap-yellow': 'text-[#fbb040]',
		'yaap-black': 'text-[#0C1518]',
		'yaap-gray': 'text-[#8F9FA3]',
	};

	// Get the appropriate classes
	const bgClass = bgColorClasses[bgColor];
	const textClass = textColorClasses[textColor];

	return (
		<button
			className={`flex gap-3 items-center justify-center px-5 py-3 font-extrabold leading-none text-center ${textClass} ${bgClass} rounded-[100px] hover:opacity-90 transition-opacity shadow-md`}
			aria-label={text}
			onClick={onClick}
		>
			<span>{text}</span>
			{iconUrl && (
				<img
					src={iconUrl}
					alt=''
					className='object-contain shrink-0 w-5 h-5 aspect-square'
				/>
			)}
		</button>
	);
};
